import React from 'react';
import { test, expect } from '@playwright/experimental-ct-react17';
import { TextField } from './TextInput';
import { Button } from './Button';
import { TextFieldControlled } from './TextInput.spec-stories';

test('form integration', async ({ mount, page }) => {
  await page.route('*/**/api/form', async route => {
    const formData = await route.request().postDataJSON();

    expect(formData).toEqual({ name: 'John' });

    await route.fulfill({ status: 200 });
  });

  const component = await mount(
    <form action="/api/form" method="post">
      <TextField label="Name" name="name" />
      <Button type="submit">Submit</Button>
    </form>,
  );

  await component.getByLabel('Name').fill('John');
  await expect(component.getByLabel('Name')).toHaveValue('John');
  await component.getByRole('button', { name: 'Submit' }).click();
});

test('controlled', async ({ mount }) => {
  const component = await mount(<TextFieldControlled />);

  await component.getByLabel('Name').fill('John');
  await expect(component.getByLabel('Name')).toHaveValue('John');
});
